import axiosInstance from "../../axios";

export async function getApplications(
  page: number,
  per_page: number,
  keyword: string,
  review_status: string,
  type: string,
  order = "-date_offer,-contract_no",
  summary_filter?: "needs_action" | "reminder_attention",
  g_search_checked?: "0" | "1",
  action_type?: "new_application" | "resubmission" | "lease_review" | "special_term_review",
  sms_verification_status?: "pending" | "confirmed" | "expired" | "failed" | "not_required"
) {
  // API mode
  const params: any = {
    per_page,
    page,
    keyword,
    review_status,
    type,
    order
  };

  if (summary_filter) {
    params.summary_filter = summary_filter;
  }

  if (g_search_checked !== undefined) {
    params.g_search_checked = g_search_checked;
  }

  if (action_type) {
    params.action_type = action_type;
  }

  if (sms_verification_status) {
    params.sms_verification_status = sms_verification_status;
  }

  const response = await axiosInstance.get("/applications", { params });
  return response.data;
}

export async function getApplicationsSummary() {
  const response = await axiosInstance.get("/applications/summary");
  return response.data.data;
}

export type ApplicationResubmissionAlert = {
  id: number;
  contract_code: number;
  contract_no: number | string | null;
  borrower_name: string;
  affiliate_name: string | null;
  resubmitted_at: string;
};

export async function getApplicationResubmissionAlerts(): Promise<ApplicationResubmissionAlert[]> {
  const response = await axiosInstance.get("/applications/resubmission-alerts");
  return response.data.data;
}

export async function completeApplicationResubmissionAlert(id: number) {
  const response = await axiosInstance.patch(`/applications/resubmission-alerts/${id}/complete`);
  return response.data.data;
}

export async function resendSmsVerification(contract_code: number, reason?: string) {
  const response = await axiosInstance.post(`/applications/${contract_code}/sms-verification/resend`, {
    reason: reason || "管理画面からの再送"
  });
  return response.data;
}

export async function getSmsVerificationHistory(contract_code: number) {
  const response = await axiosInstance.get(`/applications/${contract_code}/sms-verification/history`);
  return response.data;
}
